export * from './lib/server-data-access-otp.module';
export * from './lib/exceptions';
export * from './lib/models/otp-entity';
export * from './lib/services/otp.data-service';
